import axios from 'axios';
import logComponent from '../logComponent';
import getConfig from './getConfig';

const UserMessage = (function () {
  function id(messageThreadId) {
    if (logComponent('UserMessage')) { console.debug('UserMessage id'); }
    const params = { messageThreadId };

    return axios.get('api/UserMessage/0', getConfig(params));
  }

  function GetThreadsForCurrentUser() {
    if (logComponent('UserMessage')) { console.debug('UserMessage GetThreadsForCurrentUser'); }
    return axios.get('api/UserMessage/GetThreadsForCurrentUser', getConfig());
  }

  function GetUnreadThreadCountForCurrentUser() {
    if (logComponent('UserMessage')) { console.debug('UserMessage GetUnreadThreadCountForCurrentUser'); }
    return axios.get('api/UserMessage/GetUnreadThreadCountForCurrentUser', getConfig());
  }

  function Create(userMessage) {
    if (logComponent('UserMessage')) { console.debug('UserMessage Create'); }
    return axios.post('api/UserMessage/Create', userMessage, getConfig());
  }

  function ToggleReadStatus(messageThreadId, isReadByFamily, isReadByFacility) {
    if (logComponent('UserMessage')) { console.debug('UserMessage ToggleReadStatus'); }
    const params = { messageThreadId, isReadByFamily, isReadByFacility };

    return axios.put('api/UserMessage/ToggleReadStatus', null, getConfig(params));

  }

  return {
    id,
    GetThreadsForCurrentUser,
    GetUnreadThreadCountForCurrentUser,
    Create,
    ToggleReadStatus
  }
})();

export default UserMessage;